module.exports = __webpack_public_path__ + "img/adrift-in-the-harbor-2.0828ed61.webp";